import { render } from "./ScrollBtn.vue?vue&type=template&id=49410e58"
import script from "./ScrollBtn.vue?vue&type=script&lang=js"
export * from "./ScrollBtn.vue?vue&type=script&lang=js"

import "./ScrollBtn.vue?vue&type=style&index=0&id=49410e58&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__